export const isCdnAsset = (src) => {
  return /^\/?cms\//.test(src) || /^https?:\/\//.test(src);
};
